import TablePage from '@/found/components/table_page';
import Form from './form';

export default {
  name: 'channelPoolMain',
  extends: TablePage,
  data() {
    return {};
  },
  components: {
    Form,
  },
  created() {
    this.getConfigList('mainList');
  },
  methods: {
    clickVisible({
      row,
      val: { code },
    }) {
      const {
        approveStatus,
      } = row;
      // 审批通过 approved,审批中 approving,活动关闭 closed,流程追回 interrupt,驳回 rejected
      if (code === 'edit' && approveStatus !== '3' && approveStatus !== '0') {
        return false;
      }

      return true;
    },
    modalClick({ val, row }) {
      if (val.code === 'add' || val.code === 'edit' || val.code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        console.log(this.modalConfig);
        this.modalConfig.title = val.name || '查看';
        this.openFull();
      }
    },
  },
};
